import merge from 'lodash/merge';

export default (state = {}, action) => {
  if (action.payload && action.payload.entities) {
    return merge({}, state, action.payload.entities);
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/entities/index.js